import { createFileRoute, Outlet } from '@tanstack/react-router';
import { OrgProvider } from '@/auth/OrgContext';

export const Route = createFileRoute('/_client')({
  component: () => (
    <OrgProvider>
      <Outlet />
    </OrgProvider>
  ),
});
